export interface Service {
  title: string;
  description: string;
}

export interface HomeData {
  name: string;
  email: string;
  expertise: string[];
  bio: string;
  services: Service[];
}

export const homeData: HomeData = {
  name: "Elliott Regan",
  email: "hello@elliottregan.com",
  expertise: ["Enterprise Scale", "Team Leadership", "AI Strategy"],
  bio: "I solve complex problems at scale and build the teams that sustain them. Over 15 years across healthcare, education, telecom, and enterprise systems, I've learned that great architecture starts with great people—and both require leading with clarity, not complexity.",
  services: [
    {
      title: "Architecture & Design",
      description:
        "Design scalable, maintainable, and reliable architectures that address root causes, not symptoms.",
    },
    {
      title: "Technical Leadership",
      description:
        "Mentor senior engineers, guide technical decision-making across teams, and elevate organizational engineering maturity.",
    },
    {
      title: "AI Strategy & Design",
      description:
        "I bridge the gap between AI possibilities and practical business outcomes while building sustainable team expertise.",
    },
  ],
};
